<template>
    <!-- <transition name="slide-down" mode="in-out"> -->
        <div class="container" v-if="errors">
            <div class="columns">
                <div class="column is-12">
                    <div class="notification is-danger">
                        <button class="delete" @click="clearAuthErrors"></button>
                        <span v-html="errors"></span>
                    </div>
                </div>
            </div>  
        </div>
    <!-- </transition> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'home',
    computed: {
        ...mapGetters({
            errors: 'auth/errors'
        }),
    },

    methods: {
        ...mapActions({
            clearAuthErrors: 'auth/clearAuthErrors',
        }),
    }
}
</script>

<style>

</style>